import React, { useEffect, useState } from "react"
import { makeStyles } from "@material-ui/core/styles"
import { Box } from "@material-ui/core"
import useStore from "src/v2/utils/store"
import CustomModal from "../../ui-components/custom-modal"
import CustomInputText from "../../form-components/custom-input-text"
import { useAlertStore } from "src/v2/utils/alert-store"

const useStyles = makeStyles((theme) => ({
  formContainer: {
    marginTop: theme.spacing(2),
    width: "100%",
  },
  errorText: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(1),
    fontSize: "0.875rem",
  },
}))

export default function SimulationNameInputModal() {
  const classes = useStyles()
  const showSimulationNameInputModal = useStore(
    (state) => state.showSimulationNameInputModal,
  )
  const setSimulationNameInputModal = useStore(
    (state) => state.setSimulationNameInputModal,
  )
  const createNewSimulation = useStore((state) => state.createNewSimulation)
  const createSimulationWithAI = useStore(
    (state) => state.createSimulationWithAI,
  )
  const oneReview = useStore((state) => state.oneReview)
  const showAlert = useAlertStore((s) => s.showAlert)

  const [simulationName, setSimulationName] = useState("")
  const [simulationNameHasError, setSimulationNameHasError] = useState(false)
  const [simulationNameErrorText, setSimulationNameErrorText] = useState("")
  const [creatingSimulation, setCreatingSimulation] = useState(false)

  // Reset form when modal opens
  useEffect(() => {
    if (showSimulationNameInputModal) {
      setSimulationName("")
      setSimulationNameHasError(false)
      setSimulationNameErrorText("")
      setCreatingSimulation(false)
    }
  }, [showSimulationNameInputModal])

  const validateSimulationName = () => {
    if (!simulationName.trim()) {
      setSimulationNameHasError(true)
      setSimulationNameErrorText("Simulation name required")
      return false
    }

    if (simulationName.trim().length > 200) {
      setSimulationNameHasError(true)
      setSimulationNameErrorText(
        "Simulation name must be less than 200 characters",
      )
      return false
    }

    setSimulationNameHasError(false)
    setSimulationNameErrorText("")
    return true
  }

  const createSimulation = async () => {
    if (!validateSimulationName()) {
      return false
    }

    setCreatingSimulation(true)
    const simulationParams = {
      review_id: oneReview._id,
      name: simulationName.trim(),
    }
    await createNewSimulation(simulationParams, showAlert)
    setSimulationNameInputModal(false)
    setCreatingSimulation(false)
  }

  const onCreateSimulationUsingAIClick = async () => {
    if (!validateSimulationName()) {
      return
    }

    setCreatingSimulation(true)
    const simulationParams = {
      review_id: oneReview._id,
      name: simulationName.trim(),
    }
    await createSimulationWithAI(simulationParams, showAlert)
    setSimulationNameInputModal(false)
    setCreatingSimulation(false)
  }

  return (
    <CustomModal
      size="medium"
      title={"Create Simulation"}
      showModal={showSimulationNameInputModal}
      onCloseModal={() => setSimulationNameInputModal(false)}
      submitBtnText={"Create"}
      onSubmit={async (e) => {
        e.preventDefault()
        let updateResponse = await createSimulation()
        if (updateResponse) {
          setSimulationNameInputModal(false)
        }
      }}
      onSecondaryRightBtnSubmit={(e) => {
        e.preventDefault()
        onCreateSimulationUsingAIClick()
      }}
      cancelBtnDisabled={creatingSimulation}
      submitBtnDisabled={creatingSimulation}
      loading={creatingSimulation}
      secondaryRightBtnText={"Create with AI"}
      secondaryBtnLoading={creatingSimulation}
    >
      <Box className={classes.formContainer}>
        <form
          onSubmit={async (e) => {
            e.preventDefault()
            let updateResponse = await createSimulation()
            if (updateResponse) {
              setSimulationNameInputModal(false)
            }
          }}
        >
          <CustomInputText
            label={"Simulation name"}
            required={true}
            value={simulationName}
            onChange={(value) => {
              setSimulationName(value)
            }}
            hasError={simulationNameHasError}
            errorMessage={simulationNameErrorText}
            autoFocus={true}
            direction="column"
            disabled={creatingSimulation}
          />
        </form>
      </Box>
    </CustomModal>
  )
}
